export default __webpack_public_path__ + "static/3ca470fd-8270-41e1-a8a8-1ab7f428bf19-3006834eb0c591ed5cc45d1fc154738b.woff2";